import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  formLabel: {
    color: "#308CDB",
    lineHeight: "1.5rem",
    weight: "bold",
    marginBottom: "0.8rem !important",
  },
}));

export default styles;
